<template>
  <div v-lenis-scroll class="takat-right-container">
    <div class="takat-right-inner">
      <div class="takat-Inner-left" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
        <div class="takat-Inner-scrollImage">
          <img
            v-lazy="shopifyData.logoImage"
            alt="Takat Logo"
            loading="lazy"
            aria-hidden="true"
            aria-label="Takat Logo"
            width=""
            height=""
          />
        </div>
      </div>
    </div>

    <div class="takat-Inner-content-grid">
      <div />
      <div>
        <div style="height: fit-content">
          <div class="takat-Inner-scrollImage-res">
            <img
              v-lazy="shopifyData.logoImage"
              alt="Takat Logo"
              loading="lazy"
              aria-hidden="true"
              aria-label="Takat Logo"
              width=""
              height=""
            />
          </div>
        </div>
        <!-- Right Grid Part  -->
        <div class="productsGrid rightside">
          <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
            <a
              v-if="value.showCollection == 'true'"
              :href="value.collectionLink"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                <div class="tharProductPriceInfo">
                  <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice" class="tharProductPrice">
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span
                    v-if="value.product.compare_at_price > '1'"
                    class="discountPercentage tharProductPrice"
                  >
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                />
              </div>
            </a>

            <a
              v-else
              :href="value.product.productUrl"
              :product-id="value.product.productid"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h1 class="tharProductTitle">{{ value.product.productTitle }}</h1>
                <div class="tharProductPriceInfo">
                  <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice" class="tharProductPrice">
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span
                    v-if="value.product.compare_at_price > '1'"
                    class="discountPercentage tharProductPrice"
                  >
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { currencyJson } from '@/currency';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage: this.shopifyData.desktopBannerBg,
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;

    this.updateBackgroundImage();

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    //Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);
    function animateSection(section) {
      ScrollTrigger.matchMedia({
        '(min-width: 769px)'() {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.takat-right-inner'),
                scrub: 2,
                start: 'top 90%',
                end: '100% center',
                // markers:true
              },
            })
            .to(
              section.querySelector('.takat-right-inner'),
              {
                position: 'sticky',
                top: 0,
              },
              'b'
            )
            .to(
              section.querySelector('.takat-Inner-scrollImage'),
              {
                margin: '0',
                duration: 1,
              },
              'b'
            );
        },
        '(max-width: 768px)'() {
          // console.log("this is on Mobile");
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.takat-Inner-left'),
                start: '40% 20%',
                end: 'bottom -100%',
                scrub: true,
                // markers:true
              },
            })
            .fromTo(
              section.querySelector('.takat-Inner-left'),
              {
                backgroundSize: '180%',
              },
              {
                backgroundSize: '120%',
              }
            );
        },
        all() {
          ScrollTrigger.refresh();
        },
      });
    }

    // Apply animation to each section
    document.querySelectorAll('.takat-right-container').forEach((section) => {
      animateSection(section);
    });
  },
  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 768) {
        this.backgroundImage = this.shopifyData.mobBannerBg;
      } else {
        this.backgroundImage = this.shopifyData.desktopBannerBg;
      }
    },
  },
};
</script>

<style scoped>
.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #ffff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage .tharProductPrice del {
  color: grey;
}

.productsGrid .grid_item {
  position: relative;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.heading-text2 {
  color: white;
  text-wrap: nowrap;
  padding-top: 30%;
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.43;
  text-align: center;
  font-family: 'PP Editorial New', sans-serif;
}

.grid_item_img img {
  display: block;
}

.rightside {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  backdrop-filter: blur(100px);
  background-image: linear-gradient(rgb(240 241 244), rgb(240 241 244));
  background-color: #f0f1f4;
}

.rightside img {
  width: 100%;
  height: 100%;
}

.secleft {
  position: relative;
}

.heading-text-bottom2 {
  color: #fff;
  font-family:
    Helvetica Neue,
    sans-serif;
  font-size: 14.99px;
  font-weight: 700;
  line-height: 13.64px;
  letter-spacing: 0.11em;
  text-align: center;
  text-wrap: nowrap;
  display: block;
}

.takat-right-inner {
  position: relative;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.takat-Inner-left {
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left;
}

.heading-text2-res {
  display: none;
}

.takat-Inner-content-grid {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  position: relative;
  z-index: 2;
}

.takat-Inner-scrollImage {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  width: 50%;
  height: 100vh;
  margin: 0 auto;
}

.takat-Inner-scrollImage img {
  max-width: 130px;
}

.scrollingtext {
  display: flex;
}

.takat-Inner-scrollImage-res {
  display: none;
}

@media only screen and (max-width: 1150px) {
  .heading-text2 {
    font-size: 34px;
    line-height: 1.9;
  }

  .heading-text-bottom2 {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1024px) {
  .heading-text,
  .heading-text-bottom,
  .heading-text2,
  .heading-text-bottom2 {
    text-align: center;
  }
}

@media only screen and (max-width: 768px) {
  .takat-Inner-left {
    height: 100vh;
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
  }

  .scrollingtext {
    display: none;
  }

  .heading-text-res-section2 {
    padding-bottom: 134px;
    font-size: 36px;
    font-style: italic;
    font-weight: 200;
    line-height: 0.9;
    text-align: center;
    font-family: 'PP Editorial New', sans-serif;
  }

  .heading-text-bottom-res-section2 {
    font-family:
      Helvetica Neue,
      sans-serif;
    font-size: 14.99px;
    font-weight: 700;
    line-height: 13.64px;
    letter-spacing: 0.11em;
    text-align: center;
    color: #fff;
  }

  .takat-Inner-scrollImage-res {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 9;
    padding-bottom: 45px;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .takat-Inner-scrollImage-res img {
    max-width: 50px;
  }

  .heading-text2-res {
    display: block;
    font-size: 34px;
    line-height: 60px;
    font-weight: 400;
    color: #fff;
    text-wrap: nowrap;
    padding-top: 30%;
  }

  .takat-right-inner {
    position: sticky;
    top: 0;
  }

  .takat-Inner-scrollImage {
    display: none;
    justify-content: end;
    height: 98vh;
    margin: 0 auto;
    gap: 40%;
  }

  .takat-Inner-content-grid {
    grid-template-columns: 0% 100%;
  }

  .rightside {
    width: 100%;
    transform: translateX(0);
  }

  .heading-text2 {
    display: none;
    text-align: center;
    font-size: 36px;
    text-wrap: nowrap;
  }

  .heading-text-bottom2 {
    text-align: center;
    font-size: 15px;
    color: #fff;
  }

  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.01em;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
